export enum AggregationType {
  Opportunity,
  Amount,
}
